import { TickIcon } from '@/Assets/Icons/Tick';
import { Image } from '@/components/Image';
import { useResizeObserver } from '@/hooks/useResizeObserver';
import clsx from 'clsx';
import {
  motion,
  useMotionValueEvent,
  useScroll,
  useTransform,
} from 'framer-motion';
import { useRef, useState } from 'react';
import { useWindowSize } from 'usehooks-ts';
import { mainPhasesData } from './configs';
import './styles.css';

export function Phases() {
  const { width: screenWidth } = useWindowSize();
  const { width = document.body.offsetWidth } = useResizeObserver({
    refId: 'main-page-viewport',
  });
  const targetRef = useRef(null);
  const [currentPhase, setCurrentPhase] = useState(0);
  const { scrollYProgress } = useScroll({
    target: targetRef,
  });

  const itemHeightVh = screenWidth > 800 ? 58.41 : 100;

  const lastItemHeight = screenWidth > 800 ? -40 : 0;

  const maskPosition = useTransform(
    scrollYProgress,
    [0, 0.2, 1],
    [
      '0 calc(-50vh - 0px)',
      `0 calc(${screenWidth > 800 ? 8.41 : 20}vh - 0px)`,
      `0 calc(${(mainPhasesData.length - (screenWidth > 800 ? 2 : 1)) * itemHeightVh - lastItemHeight}vh - ${screenWidth > 800 ? 206 : 300}px)`,
    ]
  );

  useMotionValueEvent(scrollYProgress, 'change', latest => {
    if (latest < 0.2) {
      setCurrentPhase(0);
    } else if (latest < 0.5) {
      setCurrentPhase(1);
    } else if (latest < 0.9) {
      setCurrentPhase(2);
    } else {
      setCurrentPhase(3);
    }
  });

  return (
    <div className="main-page--phases" ref={targetRef}>
      {mainPhasesData.map((phase, i) => (
        <div
          key={i}
          className={clsx(
            'main-page--phases-item',
            currentPhase === i && 'active'
          )}
        >
          <div className="main-page--phases-item--bg" style={{ width: width }}>
            <Image src={phase.background} draggable={false} alt="" />
          </div>
          <div className="main-page--phases-general-info">
            <img
              src={phase.nftThumbnail}
              className="main-page--phases-nft-image"
              alt=""
            />
            <div>
              <div className="main-page--phases-heading">{phase.name}</div>
              <div className="main-page--phases-badge">{phase.startDate}</div>
            </div>
          </div>
          <div className="main-page--phases-item-content">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{
                opacity: currentPhase === i ? 1 : 0,
                filter: currentPhase === i ? 'blur(0)' : 'blur(10px)',
              }}
              transition={{ duration: 0.2 }}
              className="main-page--phases-item-description"
            >
              {phase.description}
            </motion.div>
            <ul className="main-page--phases-list">
              {phase.list.map((item, j) => (
                <motion.li
                  key={j}
                  initial={{ opacity: 0 }}
                  animate={{
                    opacity: currentPhase === i ? 1 : 0,
                    filter: currentPhase === i ? 'blur(0)' : 'blur(10px)',
                  }}
                  transition={{ duration: 0.2, delay: (j + 1) * 0.1 }}
                >
                  <div className="main-page--phases-list--indicator">
                    <TickIcon />
                  </div>
                  {item}
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
      ))}
      <motion.div
        className="main-page--phases-progress"
        style={{
          y: maskPosition,
          maskPosition: maskPosition,
        }}
      >
        <div className="main-page--phases-progress-bar" />
        {mainPhasesData.map((_, i) => (
          <div
            key={i}
            className={clsx(
              'main-page--phases-progress--indicator',
              currentPhase === i && 'active'
            )}
            style={{
              top: `${itemHeightVh * i}vh`,
            }}
          />
        ))}
      </motion.div>
    </div>
  );
}
